<template>
    <div id="pema-calculator-app" class="pama-app" :class="{'light-theme': lightTheme}">
				<div class="user-info" v-if="userName">
					<div class="username">שלום {{userName}}</div>
					<div>
						<a href="javascript:void(0)" @click="logout">התנתק</a>
					</div>
				</div>
				<div class="agencies-dd" v-if="userName && agencies">
					<label>סוכנות</label>
					<select v-model="agencyId" @change="agencyChanged">
						<option :value="null">בחירת סכנות</option>
						<option v-for="agencyOption in agencies"
										:key="agencyOption.id"
										:value="agencyOption.id"
						>{{agencyOption.name}}</option>
					</select>
				</div>
        <router-view></router-view>
				<div class="footer">
					<div v-if="userName" class="footer-menu">
						<button
								v-if="agentAreaEnabled && !editingCars"
								type="button"
								@click="goToAgentsArea"
						>להעלאת רכבים</button>
						<button
								v-if="editingCars"
								type="button"
								@click="goToCalculator"
						>למעבר למחשבון</button>
					</div>
					<div class="credits">כל הזכויות שמורות © 2025 פמה <a href="https://pama.co.il" target="_blank">מימון לרכב</a></div>
          <div v-if="isNotPama" class="terms">
            <p>אי עמידה בפירעון ההלוואה עלול לגרור חיוב בריבית פיגורים והליכי הוצאה לפועל. החברה המממנת-  פמה ליסינג בע"מ מ.ר. 54892 או חברות הבנות שלה ("פמה"). מתן ההלוואה כפוף למדיניות פמה ומותנה באישורה. מחשבון ההלוואה מהווה כלי עזר בלבד לצורך מתן אינדיקציה כללית אודות תנאי הלוואה כלשהי. תנאי השימוש ל<a href="https://pama.co.il/%d7%9e%d7%97%d7%a9%d7%91%d7%95%d7%9f-%d7%9e%d7%99%d7%9e%d7%95%d7%9f-%d7%9c%d7%a8%d7%9b%d7%91/#/">מחשבון מימון לרכב מפורטים באתר פמה</a></p>
          </div>
				</div>
				<template v-if="loading">
					<loading
							v-model:active="loading"
							:can-cancel="true"
							:is-full-page="true"
					/>
				</template>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Loading from 'vue-loading-overlay';

export default {
    name: 'App',
		components: {Loading},
    computed: {
			agency:{
				get(){
					return this.$store.getters.agency
				},
				set(value){
					this.$store.commit('agency', value)
				}
			},
			agencyId:{
				get(){
					return this.$store.getters.agencyId
				},
				set(value){
					localStorage.setItem('agencyId', value)
					this.$store.commit('agencyId', value)
				}
			},
			editingCars(){
				return this.$route.path.startsWith('/agents-area');
			},
      isNotPama(){
        return window.location.hostname !== 'pama.co.il'
      },
      ...mapGetters(['token','pToken','token','agencies','userName','agentAreaEnabled', 'lightTheme', 'loading'])
    },
    methods: {
			async agencyChanged(){
				await this.$store.dispatch('loadInterests')
			},
			goToAgentsArea(){
				this.$router.push({
					name: 'agents-area'
				});
			},
			goToCalculator(){
				this.$router.push({
					name: 'home'
				});
			},
      ...mapActions(['reportEvent','logout'])
    },
		async beforeCreate() {
			if(this.$store.getters.token){
				await this.$store.dispatch('loadAgencies')
				const agencyId = localStorage.getItem('agencyId')
				if(agencyId){
					this.$store.commit('agencyId', agencyId)
				}
			}
		},
		mounted() {
      this.$nextTick(() => {
        if(this.pToken){
          this.reportEvent({user_id: this.pToken}, 'PageView')
        }
      })
    }
}
</script>
<style src="@vueform/slider/themes/default.css"></style>
<style lang="scss">
:root {
	--red: #53AFF8;
  --primary-color: #53AFF8;
  --secondary-color: #2DF8A9;
	--btn-bg: #bd2e39;
	--btn-bg-invert: #fff;
	--btn-text-invert: #000000;
	--btn-text: #fff;
	--font-color: #ffffff;
	--input-font-color: #27306E;
	--inverse-color: #2e3172;
}

body {
	overflow-x: hidden;
}

.pama-app {

  .terms {
    font-size: 0.75rem;
    color: var(--font-color);
    padding-bottom: 15px;
    a,a:visited {
      color: var(--font-color);
      font-weight: bold;
    }
  }

	padding: 0 15px;
	width: 100%;

	select {
		max-width: 100%;
	}

	.credits {
		color: var(--font-color);
		font-size: 0.75rem;
		margin-top: 15px;
		text-align: center;
		padding-bottom: 25px;

		a {
			color: var(--font-color);

			&:focus,
			&:hover,
			&:visited {
				color: #fff;
			}
		}
	}

	.user-info {
		position: absolute;
		top: 10px;
		right: 10px;
		color: var(--font-color);

		a {
			color: var(--font-color);
		}
	}

	.agencies-dd {
		position: absolute;
		top: 65px;
		right: 10px;
		color: var(--font-color);

		label {
			display: block;
		}
	}

	.agents-area,
	.footer {

		button {
			background-color: var(--btn-bg);
			color: var(--btn-text);
			font-size: 20px;
			font-weight: 400;
			line-height: 28px;
			letter-spacing: 0;
			border: none;
			min-width: 259px;
			text-align: center;
			border-radius: 5px;
			&:disabled {
				background-color: #979797;
			}
			&.white {
				background-color: var(--btn-text);
				color: var(--inverse-color);
			}
			&.delete {
				background-color: #7c7c7c;
				color: var(--btn-text);
			}

			&.active {
				background-color: var(--btn-text);
				color: var(--btn-bg);
			}
		}

		.footer-menu {
			display: flex;
			flex-flow: row wrap;
			margin-top: 90px;
			justify-content: center;
		}
	}


	@media (max-width: 1024px) {
		.user-info {
			margin-top: 15px;
		}


		.user-info,
		.agencies-dd {
			position: relative;
			top: auto;
			left: auto;
			right: auto;
			margin-bottom: 15px;
		}

		.agencies-dd {
			margin-bottom: 35px;
		}

		.footer-menu {
			position: fixed;
			bottom: 0;
			right: 0;
			left: 0;
			padding: 10px;
			background-color: #fff;
		}

		.credits {
			padding-bottom: 65px;
		}
	}
}
</style>
